import { AxiosRequestConfig, AxiosResponse } from 'axios'
import contentDisposition from 'content-disposition'
import { saveAs } from '../browser'
import { createRequestInstance } from './createRequestInstance'

const baseRequestConfigs: AxiosRequestConfig = {
  baseURL: '',
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  validateStatus(_status: number) {
    return true
  },
}

// 在 frontends/configs/mockApi/devMockApis.ts 里面配置 mock
// ！！！警告
// 原则上中间件不允许替换 request 对像
// 但是这里的 request 是可直接使用的函数
const request = createRequestInstance(baseRequestConfigs)

// 根据 axios 底层源码、异常请求结果抛出异常，或者通过 reject 返回
async function withFailResp<T extends () => any>(
  apiFunc: T,
): Promise<ReturnType<T>> {
  try {
    return await apiFunc()
  } catch (ex) {
    const { response } = ex
    if (response) {
      return response
    }
    throw ex
  }
}

export {
  download,
  request,
  withFailResp,
}

function download(config: AxiosRequestConfig) {
  // axios 默认期望的返回类型是 json，对于下载型的内容，服务端返回的是二进制类型，
  // 这里必须设置为 blob，否则 axios 在收到响应后会报错
  config.responseType = 'blob'

  return request(config).then((res: AxiosResponse) => {
    // 从响应的 Content-Disposition Header 中读取文件名
    // XXX 目前文件名由后端决定，是否需要由前端决定文件名？
    const disposition = contentDisposition.parse(res.headers['content-disposition'])
    saveAs(res.data, disposition.parameters.filename)
  })
}
